/** 
 * @type {CurrenciesFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    codes: null,
    names: null,
    is_primary: false
}
/** 
* @returns {CurrenciesFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/CurrenciesFilter.js